module.exports = __webpack_public_path__ + "static/media/ico-professionalActive.e50ef2ab.svg";